import type { ComponentProps } from "react"

export default function IndustryU(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M21.3333 3.47726V7.69326H17.3333V11.6933H21.3333V15.6933L17.3333 17.0266L14.6667 23.6933L8 19.6933V11.6933L12 9.02659V2.97192C9.01634 3.90721 6.45592 5.86066 4.7657 8.49128C3.07549 11.1219 2.36284 14.2626 2.75218 17.3651C3.14151 20.4676 4.60809 23.3348 6.8959 25.4662C9.1837 27.5976 12.1474 28.8578 15.2697 29.0269C18.3919 29.1959 21.4743 28.263 23.9789 26.3911C26.4835 24.5192 28.251 21.8271 28.9731 18.7847C29.6951 15.7424 29.3257 12.5432 27.9294 9.74543C26.5331 6.9477 24.1986 4.72922 21.3333 3.47726Z"
        fill={fill}
      />
    </svg>
  )
}
